(function($, undefined) {
	"use strict";
	
	let formValidator;
	const REMINDER_DATA_JOINING_CHARACTER = "::";

	function init() {
		formValidator = Fw.component.models().form;
		$('#add-external-user').on('click', onAddExternalUser);
		$('.wizard_step7 .wizard__questions').on('submit', onFormSubmit);
		$('#wizard-more-btn-no').on('click', onNoBtnClick);
		$('#wizard-more-btn-yes').on('click', onYesBtnClick);
		$('.wizard-extra-checklist-btn').on('click', onExtraOrDeleteQuestionsClick);
		$('.wizard__button .checklist-form-question__delete-btn').on('click', onExtraOrDeleteQuestionsClick);
	}

	function onExtraOrDeleteQuestionsClick() {
		setTimeout(() => {
			let items = $('.checklist-form-question_wizard:not(.checklist-form-question_template)');
			let select = $('[name="selected-checklist"]');

			if (items.length) {
				select.removeClass('required error');
			} else {
				select.addClass('required');
			}
		});
	}

	function onAddExternalUser({ currentTarget }) {
		let btn = $(currentTarget);
		let template = $('.reminder-email-block_template');
		let clone = template.clone(true, true).removeClass('reminder-email-block_template');

		clone.find('input').val('');
		clone.insertBefore(btn.parent());
	}

	function onFormSubmit(e) {
		let form = $(e.currentTarget);
		let field6 = $('[name="field6"]');
		let items = form.find('#wizard-users-list .location-form-editable-list-item_full:not(.template)');

		if (form.find('.wizard__button').length == 0) {
			return;
		}

		e.preventDefault();

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			$('[name="users"]', form).val(items.map((i, el) => el.dataset.itemId).get().join());

			e.preventDefault();

			switch (field6.val()) {
				case "1":
					parseFields();
					break;
				case "2":
					parseChecklists();
					break;
				case "3":
					parseDocument();
					break;
			}
			parseContacts();

			openPopupById('wizard-step-7-more-buttons');
		}
	}

	function parseFields() {
		$('[name="field7"]').val(JSON.stringify({
			fields: $('.add-modify-page-inner-item-ctn__edit_buttons-page').map((i, el) => {
				let textarea = el.querySelector('textarea');
				let text = textarea.value;
				try { text = tinymce.get(textarea.id).getContent(); } catch (e) { /* Voluntarily ignoring error */ }
				return ({
					"name": el.querySelector('input').value,
					"text": text
				});
			}).get()
		}));
	}

	function parseDocument() {
		$('[name="field7"]').val($('[name="selected-document"]').val());
	}

	function parseChecklists() {
		$('[name="field7"]').val($('[name="selected-checklist"]').val());
		getNewQuestionsData();
		getReminderInfo();
	}

	function parseContacts() {
		var form = $('.wizard__button');
		var contacts = {contacts: []};

		$('.button-contact-form:not(.button-contact-form_template)', form).each(function(i, el) {
			var name = $('[name=name]', el).val();
			var phone = $('[name=phone]', el).val();
			var email = $('[name=email]', el).val();
			contacts.contacts.push({
				name,
				phone,
				email
			});
		});
		$('[name=field18]', form).val(JSON.stringify(contacts));
	}

	function getNewQuestionsData() {
		var questionItems = $('.checklist-form-question[data-json]');
		var json = {};

		var questions = [];
		questionItems.each((i, el) => {
			questions.push(JSON.parse($(el).attr('data-json')));
		});
		json.questions = questions;

		$('[name="checklist-extra"]').val(JSON.stringify(json));
	}

	function getReminderInfo() {
		let form = $('.wizard__questions');
		let reminderJSON = {};
		let reminderUsers = getReminderContacts(form);
		let [field9, field10, field16, field17] = getRemindersInfo(form);

		reminderJSON.field9 = field9;
		reminderJSON.field10 = field10;
		reminderJSON.field16 = field16;
		reminderJSON.field17 = field17;

		if ($('[name="reminder"]', form).length === 0) {
			form.append($('<input type="hidden" name="reminder" />'));
		}
		$('[name="reminder"]').val(JSON.stringify(reminderJSON));
		
		if ($('[name="reminder-users"]', form).length === 0) {
			form.append($('<input type="hidden" name="reminder-users" />'));
		}
		$('[name="reminder-users"]').val(JSON.stringify({ "contacts": reminderUsers }));
	}

	function getRemindersInfo(ctn) {
		let recurrences = [];
		let times = [];
		let startDates = [];
		let repetitions = [];

		$('.reminder:not(.reminder_template)', ctn).each((i, reminderCtn) => {
			let timeInputCtn = $('.time-am-pm-inputs', reminderCtn);
			let time = `${$('select', timeInputCtn).val()}:00 ${$('[type="radio"]:checked', reminderCtn).val()}`;
			let recurrence = $('[name="reminder-recurrence"]', reminderCtn).val();
			let prefix;

			switch (recurrence) {
				case "daily":
					prefix = '';
					break;
				case "weekly":
					prefix = $('.for-reminder_weekly input:checked', reminderCtn)
						.map((i, el) => el.value)
						.get()
						.join();
					break;
				default:
					prefix = $(`.for-reminder_${recurrence} .form-input`, reminderCtn).val().replace(/\//g, '-');
					break;
			}

			recurrences.push(recurrence);
			times.push(`${prefix} ${time}`);
			startDates.push($('.input_start-date', reminderCtn).val());
			repetitions.push($('[name="repetition"]', reminderCtn).val());
		});


		return [
			recurrences.join(REMINDER_DATA_JOINING_CHARACTER),
			times.join(REMINDER_DATA_JOINING_CHARACTER),
			startDates.join(REMINDER_DATA_JOINING_CHARACTER),
			repetitions.join(REMINDER_DATA_JOINING_CHARACTER)
		];
	}

	function getReminderContacts(form) {
		let reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;		
		let allReminderContacts = [];
		$('.reminder:not(.reminder_template)', form).each((i, el) => {
			allReminderContacts.push($('.reminder-email-block', el).filter((i, el) => {
				let name = el.querySelector('[name="reminder-email-name"]');
				let email = el.querySelector('[name="reminder-email-email"]');
				return name.value != '' && email.value != '' && !!email.value.match(reEmail);
			}).map((i, el) => {
				let t = $(el);
				let name = el.querySelector('[name="reminder-email-name"]').value;
				let email = el.querySelector('[name="reminder-email-email"]').value;
				return ({ "name": name, "email": email });
			}).get());
		});
		return allReminderContacts;
		 
	}
	
	function onNoBtnClick() {
		updateMoreBtnInput(false);
	}

	function onYesBtnClick() {
		updateMoreBtnInput(true);
	}

	function updateMoreBtnInput(val) {
		$('[name="more-buttons"]').val(val);
		submitForm();
	}

	function submitForm() {
		$('.wizard__questions').get(0).submit();
	}
	
	$(init);
	
})(jQuery);